import { Col, Modal, Row, Table } from "antd";
import {
  fetchSurfacesWithSmilesErrors,
  sendEmailForVolSurface,
} from "api/volSurfaceApi";
import { toast } from "helpers/generalHelper";
import { useState } from "react";
import {
  CancelButton,
  PrimaryButton,
  SecondaryButton,
} from "../CustomButtons/CustomButtons";
import PreLoadPagesSpin from "components/PreLoadPagesSpin";

export default function SendEmail({ dark_Theme }) {
  const [showSendModal, setShowSendModal] = useState(false);
  const [selectedShortcuts, setSelectedShortcuts] = useState([]);
  const [isShortcutsLoading, setIsShortcutsLoading] = useState(false);
  const [isSendLoading, setIsSendLoading] = useState(false);
  const [shortcuts, setShortcuts] = useState([]);

  const handleSendEmail = () => {
    setIsSendLoading(true);
    sendEmailForVolSurface({
      shortcuts: selectedShortcuts.map(
        (item) => item?.product_contract_style_id
      ),
    })
      .then((res) => {
        if (res.status === 200) {
          const data = res?.data?.data;
          if (data?.show_warning_message) {
            toast(data?.emails_that_are_not_common_message, "warning");
          } else {
            toast(res?.data?.message, "success");
          }
          handleDownloadVolSurfaceData(data?.url);
           setTimeout(() => {
            onCancel();
           }, 1000);
         
        } else {
          toast(res?.data?.message, "warning");
        }
        setIsSendLoading(false);
      })
      .catch((err) => {
        setIsSendLoading(false);
        console.log("Error >>", err);
      });
  };

  const handleDownloadVolSurfaceData = (url) => {
    const a = document.createElement("a");
    a.href = url;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setIsSendLoading(false);
  };

  const getShortcuts = () => {
    setIsShortcutsLoading(true);
    fetchSurfacesWithSmilesErrors({})
      .then((res) => {
        setShortcuts(
          res.data?.data?.sort((a, b) => a?.label?.localeCompare(b?.label))
        );
        const selectedShortcuts = res.data?.data?.filter(
          (item) => item.selected
        );
        setSelectedShortcuts(selectedShortcuts);
        setIsShortcutsLoading(false);
      })
      .finally(() => {
        setIsShortcutsLoading(false);
      });
  };
  const hasErrors = selectedShortcuts?.some(
    (shortcut) => shortcut?.errors?.length > 0
  );

  function onCancel() {
    setShowSendModal(false);
    setSelectedShortcuts([]);
  }

  return (
    <>
      <Col span={24}>
        <Row className="bias-btn">
          <Col span={3}>Send Email:</Col>
          <Col>
            <SecondaryButton
              onClick={() => {
                setShowSendModal(true);
                getShortcuts();
              }}
            >
              Send
            </SecondaryButton>
          </Col>
        </Row>
      </Col>
      <Modal
        width={"50%"}
        className={`${dark_Theme && "ant-modal-dark content_dark"}`}
        title="Send Email Confirmation"
        style={{
          top: 20,
        }}
        confirmLoading={isSendLoading}
        open={showSendModal}
        onCancel={onCancel}
        centered
        footer={[
          <PrimaryButton
            disabled={
              isSendLoading || selectedShortcuts?.length === 0 || hasErrors
            }
            loading={isSendLoading}
            key="send"
            onClick={() => handleSendEmail()}
            tooltip={hasErrors ? "Some selections have errors." : null}
          >
            Send
          </PrimaryButton>,
          <CancelButton key="cancel" onClick={onCancel}>
            Cancel
          </CancelButton>,
        ]}
      >
        {isShortcutsLoading ? (
          <PreLoadPagesSpin
            className={"other-info--container--spin"}
            size={"large"}
            dark_Theme={dark_Theme}
          />
        ) : (
          <>
            <p className="fw-bold fs-6">Select Shortcuts</p>
            <Table
              scroll={{ y: 500 }}
              pagination={false}
              bordered
              size="small"
              className={`${dark_Theme && "table-dark"}`}
              rowKey={(record) => record?.product_contract_style_id}
              dataSource={shortcuts?.map((item, index) => ({
                ...item,
                key: item?.product_contract_style_id,
                errors: item?.errors,
              }))}
              rowSelection={{
                selectedRowKeys: selectedShortcuts?.map(
                  (item) => item?.product_contract_style_id
                ),
                type: "checkbox",
                onChange: (selectedRowKeys, selectedRows) => {
                  setSelectedShortcuts(selectedRows);
                },
              }}
              columns={[
                {
                  title: "Shortcut",
                  dataIndex: "label",
                  key: "label",
                  width: "30%",
                },
                {
                  title: "Errors",
                  dataIndex: "errors",
                  key: "errors",
                  render: (errors) => {
                    return (
                      <div className="d-flex flex-wrap gap-1">
                        {errors && errors?.length > 0 ? (
                          errors?.map((error, index) => (
                            <p
                              style={{ fontSize: "12px", fontWeight: "500" }}
                              className="m-0 px-2 text-white badge bg-danger"
                              key={error}
                            >
                              {index + 1}. {error}
                            </p>
                          ))
                        ) : (
                          <p style={{ fontSize: "12px" }} className="m-0 p-0 ">
                            —
                          </p>
                        )}
                      </div>
                    );
                  },
                },
              ]}
            />
          </>
        )}
      </Modal>
    </>
  );
}
